// INTERIM — replace when client finalizes genre taxonomy.
// Keep in sync with submission BE: config/curatorOfferGenres.js

export const CURATOR_OFFER_GENRES: string[] = [
  'Pop',
  'Hip-Hop/Rap',
  'Trap',
  'Drill',
  'R&B/Soul',
  'Afrobeats',
  'Amapiano',
  'Dancehall',
  'Reggae',
  'Rock',
  'Indie/Alternative',
  'Punk',
  'Metal',
  'Folk/Acoustic',
  'Singer-Songwriter',
  'Electronic/Dance',
  'House',
  'Techno',
  'Trance',
  'Drum & Bass',
  'Dubstep',
  'Lo-Fi',
  'Latin',
  'Reggaeton',
  'Regional Mexican',
  'K-Pop',
  'J-Pop',
  'Anime',
  'Country',
  'Blues',
  'Jazz',
  'Classical',
  'Gospel',
  'Christian',
  'Ambient',
  'Soundtrack',
  'World',
  'Brazilian',
  'Arabic',
  'Desi/Bollywood',
  'Sleep/Meditation',
  'Workout/Fitness',
  'Party',
  'Chill',
  'Focus',
  'Other',
];

export const CURATOR_OFFER_GENRE_SET = new Set(CURATOR_OFFER_GENRES);

/** Maximum genres a curator can select on an offer. */
export const MAX_CURATOR_OFFER_GENRES = 20;

/** Prefill for the curator offer form rate field (USD per 1K streams). */
export const DEFAULT_CURATOR_RATE_PER_1K = 5;
